import { useState } from "react"
import { EditIcon, Save, X } from "lucide-react"

import { Button } from "@f2e/ui/components/base"

type ButtonProps = React.ComponentProps<typeof Button>

export interface EditSaveButtonsProps {
  editText?: string
  saveText?: string
  cancelText?: string
  disabled?: boolean
  isLoading?: boolean
  size?: ButtonProps["size"]
  onSave: () => void | Promise<void>
  onCancel: () => void
  onEditingChange?: (isEditing: boolean) => void
}

export const EditSaveButtons = ({
  editText = "Edit",
  saveText = "Save",
  cancelText = "Cancel",
  disabled = false,
  isLoading = false,
  size = "default",
  onSave,
  onCancel,
  onEditingChange,
}: EditSaveButtonsProps) => {
  const [isEditing, setIsEditing] = useState(false)

  const handleEditClick = () => {
    setIsEditing(true)
    onEditingChange?.(true)
  }

  const handleSave = async () => {
    await onSave()
    setIsEditing(false)
    onEditingChange?.(false)
  }

  const handleCancel = () => {
    onCancel()
    setIsEditing(false)
    onEditingChange?.(false)
  }

  if (!isEditing) {
    return (
      <Button onClick={handleEditClick} disabled={disabled} size={size}>
        <EditIcon className="h-4 w-4 mr-1" />
        {editText}
      </Button>
    )
  }

  return (
    <div className="flex gap-2">
      <Button size={size} onClick={handleSave} disabled={disabled || isLoading}>
        <Save className="h-4 w-4 mr-1" />
        {isLoading ? "Saving..." : saveText}
      </Button>
      <Button
        variant="outline"
        size={size}
        onClick={handleCancel}
        disabled={isLoading}
      >
        <X className="h-4 w-4 mr-1" />
        {cancelText}
      </Button>
    </div>
  )
}

export default EditSaveButtons
